var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.414 59.414"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.268 1.414L43.854 0 14.146 29.707l29.708 29.707L45.268 58 16.975 29.707z"
  })));
}
export default SvgIconLeftArrow;